import React, { memo, useCallback } from 'react'

import {
  Button,
  Icon,
  Download2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useExportAccess from 'Pods/ThreeDStudio/Hooks/useExportAccess'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { STUDIO_EVENT, trackStudioEvent } from 'Pods/ThreeDStudio/Services/studioTracker'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { triggerExport } from 'Pods/ThreeDStudio/Store/actions/export'
import { openPaidFeatureModal } from 'Pods/ThreeDStudio/Store/actions/ui'
import { isExportInFlightForCurrentView } from 'Pods/ThreeDStudio/Store/slices/export'

const downloadIcon = <Icon svgComponent={Download2} color="dark" size={iconSize} notSpaced />

function ExportButton() {
  const t = useTranslation()
  const hasExportAccess = useExportAccess()
  const selectedFormat = useThreeDStudioStore(state => state.export.selectedFormat)
  const isInFlightForCurrentView = useThreeDStudioStore(isExportInFlightForCurrentView)
  const assetId = useThreeDStudioStore(state => state.viewer.inputThreeD)

  // When locked the button stays enabled so clicking it opens the upsell; the
  // export-specific guards (a model must be loaded, no export in flight) only
  // apply once the user actually has access.
  const isDisabled = hasExportAccess && (!assetId || isInFlightForCurrentView)

  const handleExportClick = useCallback(() => {
    if (!hasExportAccess) {
      trackStudioEvent(STUDIO_EVENT.EXPORT_CLICK, { format: selectedFormat, locked: true })
      openPaidFeatureModal()
      return
    }
    if (isDisabled) return
    trackStudioEvent(STUDIO_EVENT.EXPORT_CLICK, { format: selectedFormat, locked: false })
    triggerExport(assetId, selectedFormat)
  }, [hasExportAccess, isDisabled, assetId, selectedFormat])

  return (
    <Button
      icon={downloadIcon}
      type="secondary"
      size="small"
      variant="with-icon"
      aria-label="Export"
      disabled={isDisabled}
      onClick={handleExportClick}
      customClass="export-cluster__export"
    >
      {t('footerActions.export.label')}
    </Button>
  )
}

export default memo(ExportButton)
